import { Loader2 } from 'lucide-react'

import { Button } from '@/modules/shared/components/ui/button'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/modules/shared/components/ui/form'
import { InputPassword } from '@/modules/shared/components/ui/input-password'

import { useAuthPassword } from '../hooks/use-auth-password.hook'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/modules/shared/components/ui/select'
import { AuthLayoutComponent } from '../components/auth-layout.component'

export function AuthPasswordPage() {
	const { companies, form, isLoading, submitAuthPassword, warningToSelectCorrectlyCompany } = useAuthPassword();
	return (

		<AuthLayoutComponent
			titleAuth="Confirmar informações"
			navigation="Voltar"
			route="/login"
		>
			<Form {...form}>
				<form
					onSubmit={form.handleSubmit(submitAuthPassword)}
					className="flex flex-col gap-2"
				>

					<FormField
						control={form.control}
						name="company"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Empresa</FormLabel>
								<Select onValueChange={field.onChange} defaultValue={field.value}>

									<SelectTrigger className="w-full">
										<SelectValue placeholder="Selecione a empresa" defaultValue={field.value} />
									</SelectTrigger>
									<SelectContent className="max-h-60">
										{
											companies?.map((company) => (
												<SelectItem key={company.codigo} value={company.codigo}>{company.nome}</SelectItem>
											))

										}
									</SelectContent>
								</Select>
								<FormMessage />
							</FormItem>
						)}
					/>

					<FormField
						control={form.control}
						name="password"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Senha</FormLabel>
								<FormControl>
									<InputPassword
										{...field}
										autoCapitalize="none"
										autoComplete="off"
										placeholder="Digite sua senha"
									/>
								</FormControl>
								<FormMessage>
									{form.formState.errors?.password?.message}
								</FormMessage>
							</FormItem>
						)}
					/>

					<div className="flex flex-1 justify-end mb-4">
						<p
							onKeyUp={(e) => {
								if (e.key === 'Enter') {
									warningToSelectCorrectlyCompany()
								}
							}}
							className="cursor-pointer"
							onClick={warningToSelectCorrectlyCompany}
						>
							Esqueceu sua senha?
						</p>
					</div>

					<Button className="mt-6 w-full" type="submit">
						{isLoading && <Loader2 size={16} className="mr-2 animate-spin" />}
						Entrar
					</Button>
				</form>
			</Form>
		</AuthLayoutComponent>

	)
}
